import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PessoaTipoPipeModule } from '../pipes';

import { PessoaTipoCardControlRadioComponent } from './pessoa-tipo-card-control-radio.component';

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoPipeModule
    ],
    declarations: [
        PessoaTipoCardControlRadioComponent
    ],
    exports: [
        PessoaTipoCardControlRadioComponent
    ]
})
export class PessoaTipoCardControlRadioModule { }
